import { PayoutMethodType } from "../../Settings/components/payout/FlowAddPayoutMethod";

const US_SDK_ID_TO_INTERNAL: Record<string, PayoutMethodType> = {
  ach: "standard",
  wallet: "wallet",
  instant: "instant"
};

const INTERNATIONAL_SDK_ID_TO_INTERNAL: Record<string, PayoutMethodType> = {
  us_bank_account: "standard",
  international_bank_account: "international",
  platform_balance: "platform-balance"
};

const parseQueryParam = (
  queryParam: string,
  mapping: Record<string, PayoutMethodType>
): PayoutMethodType[] => {
  const result: PayoutMethodType[] = [];

  queryParam
    .split(",")
    .map(value => value.trim())
    .filter(Boolean)
    .forEach(value => {
      const mapped = mapping[value];
      if (mapped && !result.includes(mapped)) {
        result.push(mapped);
      }
    });

  return result;
};

export const parseAllowedUsPayoutMethods = (
  queryParam: string
): PayoutMethodType[] => parseQueryParam(queryParam, US_SDK_ID_TO_INTERNAL);

export const parseAllowedInternationalPayoutMethods = (
  queryParam: string
): PayoutMethodType[] =>
  parseQueryParam(queryParam, INTERNATIONAL_SDK_ID_TO_INTERNAL);
